import { useMemo } from "react";
import { useHomepageAvatars } from "../../hooks/useHomepageAvatars";
import { MarketingAvatarGrid } from "./MarketingAvatarGrid";

export type Props = {
  className?: string;
};

function shuffled<T>(items: T[]): T[] {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/**
 * Container for MarketingAvatarGrid.
 *
 * Reads who has agreed to appear, shuffles them once per visit so nobody is
 * always first, and stills the rotation for anyone who asked for less motion.
 * While the list is on its way the field holds its place with a spinner; if
 * nobody has agreed to appear, the hero closes up as though it were not there.
 */
export function MarketingAvatarGridContainer({ className }: Props) {
  const { data, isLoading } = useHomepageAvatars();
  const photos = useMemo(() => shuffled(data?.avatars ?? []), [data]);
  const prefersReducedMotion =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <MarketingAvatarGrid
      photos={photos}
      isLoading={isLoading}
      isRotating={!prefersReducedMotion}
      className={className}
    />
  );
}

export default MarketingAvatarGridContainer;
